import { render, staticRenderFns } from "./ApplicationsList.vue?vue&type=template&id=3f95edaf&scoped=true"
import script from "./ApplicationsList.vue?vue&type=script&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsList.vue?vue&type=style&index=0&id=3f95edaf&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95edaf",
  null
  
)

export default component.exports